module.exports = __webpack_public_path__ + "static/media/HR.d318eb80.png";